import { useState } from 'react';

export default function WhatsAppButton() {
  const [isHovered, setIsHovered] = useState(false);
  const phoneNumber = '5511917776227';
  const message = 'Olá! Gostaria de mais informações sobre os serviços de Palestra Silenciosa.';

  const handleClick = () => {
    const agro = typeof window !== 'undefined' && window.location.pathname.includes('feiras-agro');
    const msg = agro ? 'Olá! Vim pela página de feiras agro da STIB. Quero orçamento de fones sem fio para estande e/ou painéis com histórias em feira agrícola / agropecuária.' : message;
    const url = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(msg)}`;
    window.open(url, '_blank');
  };

  return (
    <button
      onClick={handleClick}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      className="fixed bottom-24 right-6 z-50 flex items-center gap-3 cursor-pointer transition-all duration-300 hover:scale-105"
      aria-label="Contato via WhatsApp"
    >
      {isHovered && (
        <span className="bg-white dark:bg-gray-800 text-secondary dark:text-white px-4 py-2 rounded-full shadow-lg dark:shadow-gray-900/50 font-body text-sm font-medium animate-fade-in whitespace-nowrap">
          Fale conosco!
        </span>
      )}

      {/* Pulse rings container */}
      <div className="relative w-14 h-14">
        {/* Outer ping ring */}
        <span className="absolute inset-0 rounded-full bg-[#25D366] opacity-40 animate-ping" />
        {/* Middle ping ring — delayed */}
        <span
          className="absolute inset-0 rounded-full bg-[#25D366] opacity-25 animate-ping"
          style={{ animationDelay: '0.4s' }}
        />
        {/* Main button */}
        <div className="relative w-14 h-14 bg-[#25D366] rounded-full flex items-center justify-center shadow-lg hover:shadow-xl transition-shadow">
          <i
            className="ri-whatsapp-line text-white text-2xl"
            style={{ animation: 'whatsapp-bounce 2s ease-in-out infinite' }}
          />
        </div>
      </div>

      <style>{`
        @keyframes whatsapp-bounce {
          0%, 100% { transform: translateY(0px) rotate(0deg); }
          25% { transform: translateY(-3px) rotate(-8deg); }
          75% { transform: translateY(-2px) rotate(6deg); }
        }
      `}</style>
    </button>
  );
}